<template>
  <!-- Sintomas de CoronaVirus style="background-image: url(&quot;@/assets/imagens/fundo_lago.jpg&quot;);" -->
  <section class="py-5 section-parallax" :style="backgroundFundo">
    <div class="container-fluid my-5 bg-light p-4 text-center" id="sintomas-corona">
      <div class="row align-items-center justify-content-center bg-danger" style="height:15vh;">
        <div class="col-md-12">
          <h1 class="text-white">SINTOMAS DE CORONAVÍRUS</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div v-resize-text="{ratio:1.0, minFontSize: '20px', maxFontSize: '100px', delay: 100}"
               class="p-2 font-weight-bold text-dark mb-3">
            <strong>Está com <br/>sintomas</strong> <span class="text-danger ">gripais</span>?
          </div>
          <div v-resize-text="{ratio:2.0, minFontSize: '10px', maxFontSize: '90px', delay: 500}">
              <strong>Se tiver sintomas respiratórios como: tosse, dor de garganta, ou outros, ligue no TeleCorona!</strong>
          </div>
          <div v-resize-text="{ratio:1.3, minFontSize: '20px', maxFontSize: '100px', delay: 100}" class="p-2 font-weight-bold">
            <img class="img-fluid rounded-circle p-1"
                 src="@/assets/imagens/logo_telefone.png"
                 alt="Fundo Cover Telefone"> (45)3055-8872
          </div>

        </div>
        <div class="col-md-6 text-center align-items-center">
          <div class="mb-4 mt-4">
            <h2>Onde procurar atendimento?</h2>
          </div>
          <div class="mb-3 animate-in-left">
            <h3 class="font-weight-bold">Mini Hospital Dr. Jorge Milton Nunes (Exclusivo Covid-19)</h3>
            <h4>Rua Dr. Cyro Fernandes do Lago, 315, Vila Pioneiro</h4>
            <a href="https://goo.gl/maps/rS8kvB9kSmvExtjM6"
               class="btn btn-outline-primary" style="width:100%">
              <h3><b>Localização</b></h3>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Bloco7Sintomas",
  data() {
    return {
      backgroundFundo: {
        backgroundImage: `url(${require('@/assets/imagens/fundo_lago.jpg')})`
      }
    }
  }
}
</script>

<style scoped>
.btn-outline-primary {
  color: #12bbad;
  background-color: transparent;
  background-image: none;
  border-color: #12bbad; }
.btn-outline-primary:hover {
  color: #fff;
  background-color: #12bbad;
  border-color: #12bbad; }
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(18, 187, 173, 0.5); }
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #12bbad;
  background-color: transparent; }
/*.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #12bbad;
  border-color: #12bbad; }*/
/*.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(18, 187, 173, 0.5); }*/
</style>